import React, { Component } from 'react';
import WithTransition from '../../hoc/WithTransition';
import classNames from 'classnames';
//import './dpit-container.scss';


class Container extends Component {
	render() {
		const mainClasses = classNames({
			[this.props.classBEMRoot]: this.props.classBEMRoot,
			[this.props.className]: this.props.className,
		});
		return (
			<div className={mainClasses}>
				{this.props.children}
			</div>
		);
	}
}

export default Container;
export const ContainerWithTransition = WithTransition(Container);
